/**
    @file Function for creating slider plugins.
    @module js/modules/slider.js
    @date Dec-2017
    @author David Nuñez <dnunez@sanservices.hn>
 */

import slick from 'slick';

const internals = {};

internals.defaults = {
	autoplay: false,
	autoplaySpeed: 10000,
	centerMode: true,
	centerPadding: '0',
	cssEase: 'linear',
	pauseOnFocus: false,
	pauseOnHover: false,
	speed: 750,
	dots: true,
	arrows: false
};


const slider = ( selector , options ) => (
    $(selector).slick(Object.assign({}, internals.defaults, options))
);

export default slider;
